<template>
  <div>
    <div v-if="isLoading">
      <div class="row justify-content-center text-center" style = "" >
        <origami></origami>
      </div> 
      <div class="col"  style="text-align:center">
        <br>
        <h4>Buscando inscripciones disponibles...</h4>
      </div>
    </div>

    <div v-if="!isLoading && proposals.length>0">
      <div v-for="propuesta in proposals" :key="propuesta.id">
        <h3 class="col text-center">Ingreso {{propuesta.name}}</h3>
        <div class="row justify-content-center text-center">
          <div v-for="call in propuesta.calls" :key="call.id">
            <Card :proposal="propuesta" :call="call" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isLoading && proposals.length==0" class="container" >
      <div class="row align-items-center">
        <h3 class="col text-center">No se encuentran inscripciones habilitadas en este momento.</h3>

      </div>
        
     
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import Card from "@/components/Card.vue";
import { HTTPFront } from "@/share.js";
import {Origami}  from 'vue-loading-spinner';

export default {
  name: "Home",
  components: {
    Card,
    Origami
  },
  data() {
    return {
      proposals: '',
      isLoading : false,
    };
  },
  created() {
    this.academicProposals();
  },
  methods: {
    academicProposals() {
      this.isLoading = true;
      this.$store.commit('setLevel', this.$route.params.level)
      HTTPFront.get("/getPublicAcademicProposals/"+this.$route.params.level).then((res) => {
        this.proposals = res.data.rows;
        this.isLoading = false;
      });
    },
  },
};
</script>
